<template>
  <v-dialog v-model="punDialog" content-class="punDialog">
    <v-card>
      <v-card-text class="pb-0">
        <v-autocomplete
          v-model="model"
          autofocus
          :items="getAtomMenuFlat"
          item-text="title"
          item-value="id"
          :placeholder="$t('Components.PowerNavigation.Placeholder')"
          :menu-props="{ 'max-width': 450 }"
        >
          <template v-slot:item="data">
            <v-list-item link :to="data.item.path" @click="punDialog = false">
              <v-list-item-avatar
                tile
                class="punIconPosition"
                :class="'nav-module-' + data.item.module"
                color="secondary lighten-5"
              >
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ data.item.title }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ data.item.level1.title }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      punDialog: false,
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      model: null,
      search: null
    };
  },
  computed: {
    ...mapGetters("menu", ["getAtomMenuFlat"])
  },
  mounted() {
    window.addEventListener("message", this.postMessageListener, false);
    document.addEventListener("keyup", this.openNavigationListener);
  },
  methods: {
    postMessageListener(event) {
      if (event.data == "openPowerUserNavigation") {
        this.punDialog = true;
      }
    },
    openNavigationListener(event) {
      if (event.altKey && event.which == 80) {
        this.punDialog = true;
      }
    }
  }
};
</script>

<style lang="scss">
.punDialog {
  align-self: flex-start;
}
.punIconPosition {
  background-position: center;
}
</style>
